import React from 'react'
import { FleetPage, Notice } from '../../../../shared/sso-workspace/fleet-page'
import { packagesAvailable } from './packages-api'

// A build with no REACT_APP_API_PACKAGES (prod before its cutover) hides the
// section from the sidebar, but a typed address still lands on its pages: they
// say so instead of calling a service that is not there (the request would hit
// the app's own host).
export const PackagesUnavailable = ({ title = 'Packages' }) =>
  <FleetPage title={title}>
    <Notice tone="warn" role="alert">Packages isn't available in this environment.</Notice>
  </FleetPage>

export const useAvailable = () => Boolean(packagesAvailable())
